import { Spacing } from "@lifesg/react-design-system/theme";
import styled from "styled-components";

export const InfiniteListItem = styled.div`
	padding: ${Spacing["spacing-8"]};
	text-align: center;
`;
